module.exports = __webpack_public_path__ + "images/_/assets/images/popup-open-dark.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/popup-open-dark.png
// module id = ./src/assets/images/popup-open-dark.png
// module chunks = 1